import { FunctionFactory } from 'survey-core';

export const licenseLastNameValidationFunctions = () => {
  FunctionFactory.Instance.register('validateLicenseLastName', (params) => validateLicenseLastName(params));
}

function validateLicenseLastName(params: any) {

  if (params.length < 2) {
    return false;
  }

  const license_name = params[0];
  const last_name = params[1];

  if (license_name.length < 1 || last_name.length < 1 ) {
    return false;
  }

  
  return license_name.toLowerCase().includes(last_name.toLowerCase());
}
